<section class="content">
  @if (editing) {
    <a (click)="editing=false; selectedPage=''" class="mt-l">< Züruck</a>
  }
  @if (error !== '' || success !== '') {
    <mat-card class="mb-m p-m">
      @if (success !== '') {
        <p>
          {{ success }}
        </p>
      }
      @if (error !== '') {
        <p>
          {{ error }}
        </p>
      }
    </mat-card>
  }
  <h1>Page Management</h1>
  @if (!editing) {
    <button mat-flat-button color="primary" (click)="editing=true">New Page</button>
  }
  @if (!editing) {
    <div class="d-flex jcsb">
      @if (dataSource.data.length > 0) {
        <div class="w-100">
          <mat-table #files [dataSource]="dataSource">
            <ng-container matColumnDef="active">
              <mat-header-cell *matHeaderCellDef>Is Active</mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.active }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="tile">
              <mat-header-cell *matHeaderCellDef>Tile</mat-header-cell>
              <mat-cell *matCellDef="let element">
                @if (element.tile) {
                  <img src="{{element.tile}}" alt="tile"/>
                }
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="page_title">
              <mat-header-cell *matHeaderCellDef>Page Title</mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.page_title }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="relative_url">
              <mat-header-cell *matHeaderCellDef>Url</mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.relative_url }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="public">
              <mat-header-cell *matHeaderCellDef> Is Public</mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.public }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="actions">
              <mat-header-cell *matHeaderCellDef class="text-center"> Aktionen</mat-header-cell>
              <mat-cell *matCellDef="let element">
                <button mat-icon-button color="primary"
                        (click)="edit(element.relative_url)">
                  <mat-icon fontSet="material-symbols-outlined" aria-hidden="false">edit</mat-icon>
                </button>
                <button mat-icon-button (click)="deletePage(element.relative_url, element.pageTitle)">
                  <mat-icon fontSet="material-symbols-outlined" aria-hidden="false">delete</mat-icon>
                </button>
              </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
          </mat-table>
        </div>
      }
    </div>
  }
  @if (editing) {
    <div>
      <app-page-form [page]="selectedPage"></app-page-form>
    </div>
  }


</section>
